import React from 'react';

const Verification = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M13.5 26.4375C13.5 26.4375 2.8125 22.6125 2.8125 11.5875V2.53125L13.5 0.5625L24.1875 2.53125V11.5875C24.1875 22.725 13.5 26.4375 13.5 26.4375Z"
        stroke="#0F1C35"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.71875 11.8125L13.3875 16.5375L18.8438 7.08752"
        stroke="#0F1C35"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="27" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Verification;
